export const statsData = [
  { id: 1, number: "10K", text: "Gen 1 Heroes" },
  { id: 2, number: "500k+", text: "Hero Combinations" },
  { id: 3, number: "0", text: "Limitations" },
];
